import { Type } from 'class-transformer';
import { capitalCase } from 'change-case';
import { getAllISOCodes, Currency } from 'iso-country-currency';
import { BaseEntity } from '@models';
import { TypeUtils } from '@utils';
import { Organization } from '../organization';
import { ProductCategoryType } from './product-category-type.enum';
import { ProductPriceType } from './product-price-type.enum';
import { ProductPriceRecurrence } from './product-price-recurrence.enum';
import { AccessoryProperties } from './accessory-properties.class';
import { ChargerProperties } from './charger-properties.class';
import { ServiceProperties } from './service-properties.class';

const COUNTRIES = getAllISOCodes();

export class Product extends BaseEntity {
	name: string;
	description?: string;
	category: ProductCategoryType;
	country?: string;
	currency?: string;
	price?: number;
	priceType?: ProductPriceType;
	priceRecurrence?: ProductPriceRecurrence;
	organizationId: string;

	@Type(() => Organization)
	organization: Organization;

	// @Type(() => AccessoryProperties | ChargerProperties)
	properties: AccessoryProperties | ChargerProperties | ServiceProperties;

	installationCost: number;

	countryAsIsoStandard(): Maybe<Currency> {
		return COUNTRIES.find(({ iso }) => iso === this.country);
	}

	getCurrencySymbol(): Maybe<string> {
		return COUNTRIES.find(({ currency }) => currency === this.currency)?.symbol;
	}

	get type(): Maybe<string> {
		if (!this.properties) {
			return undefined;
		}

		if (this.category === ProductCategoryType.CHARGING_POINT) {
			return TypeUtils.convert(ChargerProperties, this.properties).currentType;
		} else if (this.category === ProductCategoryType.ACCESSORIES) {
			return capitalCase(TypeUtils.convert(AccessoryProperties, this.properties).accessoryType);
		} else if (this.category === ProductCategoryType.SERVICE) {
			return capitalCase(TypeUtils.convert(ServiceProperties, this.properties).serviceType);
		}
	}
}
